const userReducer = (user = [], action) => {
    switch (action.type) {

        case "LOGIN":
            return [...user, action.payload]

        case "REGISTER":
            return [...user, action.payload]
            
        case "LOGOUT":
            return [...user, null]

        case "REFRESH_ACCESS_TOKEN_SUCCESS":
            return [...user, action.payload];


        default:
            return user
    }
}

export default userReducer;